import React,{ Component } from 'react';
import { connect } from 'react-redux';
import Actions from '../../../Actions';
import { sanitizeData } from '../../../Utilities/Common';

class CompanyRow extends Component{

    render(){
        let { company: { id, name, short_name, type, address, website, contact_name, contact_email, contact_phone } } = sanitizeData(this.props);
        return (
            <tr key={id+520}>
                <td><span style={{cursor: "pointer"}} onClick={() => this.props.edit(id)} className="btn-link">{name}</span></td><td>{short_name}</td><td>{type}</td><td>{address}</td><td>{website}</td><td>{contact_name}</td><td>{contact_email}</td><td>{contact_phone}</td>
            </tr>
        );
    }
}

const mapStateToProps = (state) => ({
    token: state.auth.token,
});
export default connect(mapStateToProps,Actions.types)(CompanyRow);


// WEBPACK FOOTER //
// ./src/Components/App/Companies/CompanyRow.js